import { render, staticRenderFns } from "./PDFLoader304.vue?vue&type=template&id=54b9685e&scoped=true&"
import script from "./PDFLoader304.vue?vue&type=script&lang=ts&"
export * from "./PDFLoader304.vue?vue&type=script&lang=ts&"
import style0 from "./PDFLoader304.vue?vue&type=style&index=0&id=54b9685e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b9685e",
  null
  
)

export default component.exports